class VanillaSmoothScroll {
  constructor(options = {}) {
    this.duration = options.duration || 800;
    this.easing = options.easing || "easeOutCubic";
    this.headerSelector = options.headerSelector || null;
    this.offset = options.offset || 0;

    this.handleClick = this.handleClick.bind(this);

    this.init();
  }

  init() {
    document.addEventListener("click", this.handleClick, false);
  }

  handleClick(event) {
    const link = event.target.closest('a[href*="#"]');

    if (!link) return;

    const href = link.getAttribute("href");

    if (!href || href === "#") return;

    const url = new URL(href, window.location.href);

    // 外部リンクは無視
    if (url.origin !== window.location.origin) return;

    // 別ページへのリンクはBarba側に任せる
    if (url.pathname !== window.location.pathname) return;

    const hash = url.hash;

    if (!hash) return;

    const target = document.querySelector(hash);

    if (!target) return;

    event.preventDefault();

    this.scrollToTarget(target);

    history.pushState(null, "", hash);
  }

  scrollToTarget(target) {
    const startY = window.scrollY || window.pageYOffset;
    const targetY = this.getTargetY(target);
    const distance = targetY - startY;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      const easedProgress = this.getEasing(progress);

      window.scrollTo(0, startY + distance * easedProgress);

      if (progress < 1) {
        window.requestAnimationFrame(animate);
      }
    };

    window.requestAnimationFrame(animate);
  }

  getTargetY(target) {
    const rect = target.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;

    return rect.top + scrollY - this.getOffset();
  }

  getOffset() {
    let offset = this.offset;

    if (this.headerSelector) {
      const header = document.querySelector(this.headerSelector);

      if (header) {
        offset += header.offsetHeight;
      }
    }

    return offset;
  }

  getEasing(progress) {
    if (this.easing === "linear") {
      return progress;
    }

    // easeOutCubic
    return 1 - Math.pow(1 - progress, 3);
  }

  destroy() {
    document.removeEventListener("click", this.handleClick, false);
  }
}

export default VanillaSmoothScroll;
